import React, {Fragment} from 'react';
import Box from '../layout/Box';
import TextInput from '../form/TextInput';
import CheckBox from '../form/CheckBox';
import Select from '../form/Select';
import SelectorGrid from '../form/SelectorGrid/SelectorGrid';
import {EditorField as Editor} from '../form/editor/editor';
import createEditor from '../form/ComponentEditor';

class LandingPageEditor extends React.Component {

    render() {
        const sortable = true;
        const filterable = true;
        return (
            <Fragment className="row">
                <Box
                    theme="default"
                >
                    <SelectorGrid
                        componentConfig={this.props.componentConfig}
                        columns={ {
                            id: {width:1, sortable},
                            name: {width:9, filterable, sortable}
                        } }
                        pageSize={5}
                        orderBy={{field: this.props.componentConfig.idfield, direction: "DESC"}}
                        onSelectionChange={ (selection) => this.props.loadForm(selection.value) }
                        selection={this.props.selection}
                    />
                </Box>
                <Box
                    theme="default"
                    footer={[
                        <button key="0" type="button" disabled={ !this.props.dirty } className={ "btn pull-right btn-primary"+(this.props.dirty?"":" disabled")} onClick={ this.props.saveForm }>
                            Mentés
                        </button>,
                        <button key="1" type="button" className="btn pull-left btn-primary" onClick={ this.props.pristineForm }>
                            Új
                        </button>
                    ]}
                >
                    <form onSubmit={ this.props.handleSubmit }>
                        <div className="box-body">
                            <div className="row form-row">
                                <div className="col-sm-1 col-sm-push-11">
                                    <TextInput name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
                                </div>
                                <div className="col-sm-11 col-sm-pull-1">
                                    <TextInput name="name" value={ this.props.values.name} label="Név" saveChanges={ this.props.setFieldValue }/>
                                </div>
                            </div>
                            <div className="row form-row">
                                <div className="col-sm-12">
                                    <Editor name="content" id={this.props.values.id} value={this.props.values.content} images={this.props.values.images} label="" height="400px" saveChanges={ this.props.setFieldValue }/>
                                </div>
                            </div>
                        </div>
                    </form>
                </Box>
            </Fragment>
        );
    }
}
export default createEditor({componentName: "LandingPage", WrappedComponent: LandingPageEditor});
